import { render, staticRenderFns } from "./Introduce.vue?vue&type=template&id=fbf1c95a&scoped=true"
import script from "./Introduce.vue?vue&type=script&lang=js"
export * from "./Introduce.vue?vue&type=script&lang=js"
import style0 from "./Introduce.vue?vue&type=style&index=0&id=fbf1c95a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf1c95a",
  null
  
)

export default component.exports